<template>
  <div>
    <stormy-form-group>
      <div class="col-span-2 flex items-center mt-2 -ml-1.5">
        <stormy-avatar-button />
      </div>
      <div class="col-span-3">
        <storm-ui-select
          name="salutation_id"
          :options="salutations"
          empty
          rules="required"
          placeholder=" "
          label="Anrede"
        />
      </div>
      <div class="col-span-3">
        <storm-ui-input
          name="title"
          label="Titel"
        />
      </div>

      <div class="col-span-7">
        <storm-ui-input
          name="first_name"
          label="Vorname"
        />
      </div>

      <div class="col-span-9">
        <storm-ui-input
          name="last_name"
          rules="required"
          label="Nachname"
        />
      </div>

      <div class="col-span-2" />
      <div class="col-span-13">
        <storm-ui-input
          name="company"
          label="Firma"
        />
      </div>
    </stormy-form-group>
    <stormy-form-group
      border
    >
      <div class="col-span-2" />

      <div class="col-span-13">
        <storm-ui-input
          name="email"
          label="E-Mail"
          rules="email"
        />
      </div>
      <div class="col-span-9">
        <storm-ui-input
          name="phone"
          label="Telefon"
        />
      </div>
    </stormy-form-group>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/pinia/GlobalStore'
const globalStore = useGlobalStore()
const { params } = storeToRefs(globalStore)

const salutations = computed(() => params.value.salutations.filter(item => item.id > 2))

</script>
